<template>
  <t-form labelWidth="90px">
    <!-- v-if="cptDataForm.dataSource == '4'" -->
     <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <t-form-item label="标题">
      <t-input v-model="attribute.title" size="small"/>
    </t-form-item>
    <t-form-item label="标题颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.labelColor" size="small"/>
    </t-form-item>
    <t-form-item label="标题大小">
      <t-input-number :min="13" :max="200" v-model="attribute.labelSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="数值大小">
      <t-input-number :min="13" :max="200" v-model="attribute.numSize"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="数值颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.numColor" size="small"/>
    </t-form-item>
    <t-form-item label="数值行高">
      <t-input-number :min="10" :max="200" v-model="attribute.numHeight"  size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="数值字体">
      <t-select v-model="attribute.fontFamily" size="small">
        <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
      </t-select>
    </t-form-item>
    <e-collapse title="条件配色" :expand="true">
      <div style="width: 100%;text-align: center;margin-bottom: 10px"><!--告警配置、环形图/进度图-->
        <t-row>
          <t-col :span="3"></t-col>
          <t-col :span="3">条件</t-col>
          <t-col :span="6">目标值</t-col>
        </t-row>
        <t-row style="margin-top: 14px;">
          <t-col :span="3">值</t-col>
          <t-col :span="3">
            <t-select v-model="attribute.alarmConfig.operator" size="small" style="width: 60px;">
              <t-option value=">" label=">"/>
              <t-option value="<" label="<"/>
              <t-option value="=" label="="/>
              <t-option value=">=" label=">="/>
              <t-option value="<=" label="<="/>
            </t-select>
          </t-col>
          <t-col :span="6">
            <t-input v-model="attribute.alarmConfig.threshold" size="small" style="width: 100%;"/>
          </t-col>
        </t-row>
      </div>
      <t-form-item label="数值颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.alarmConfig.color"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-num-option",
  components: {CptData },
  props: {attribute: Object,cptDataForm:Object,
     currentCpt:Object,},
  data(){
    return {
      textFamilyList:[]
    }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
  }
}
</script>

<style scoped>

</style>
